import React, { Component } from "react";
import { connect } from "react-redux";
import { noImg, noSig } from "vrcore-dashboard/dist/utilities";
import noimage from "./noimage.jpg";
import { Card, CardContent, Typography, Button, Grid } from "@material-ui/core";
import { Modal, ModalHeader, ModalFooter, ModalBody, Label } from "reactstrap";
import { getReport, getJobPackReports } from "./actions";
import PrintIcon from "@material-ui/icons/Print";
import { selectReport, IsClientInUK, clientDetails } from "./selectors";
import MapContainer from "../MapContainer";
import ReactToPrint from "react-to-print";
import styled from "styled-components";
import { StyledHeader } from "../../styles";
// import profile from "../../../../config/profile";
const MapDiv = styled.div`
    width: 97%;
    height: 200px;
`;
const Print = styled.div`
    @media print {
        margin: 0;
        padding: 0;
        width: 150%;
        transform: rotate(270deg) translate(-515mm, 0);
        transform-origin: 0 0;
    }
`;



let ref = "";
class TMPlan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: document.title,
            isPrintModalOpen: false,
            open: false,
            errored: false,
        };
        const path = props.location.pathname.split("/");
        if (path[2] === "reports") {
            props.getReport(
                path[2].replace(/-/g, "_"),
                path[3],
                path[5].replace(/_/g, " ").replace(/\./g, ":")
            );
        } else {
            props.getJobPackReports(
                props.match.params.uid,
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":")
            );
        }
    }

    togglePlan = () => {
        this.setState((state) => ({ open: !state.open }));
    };

    onError = () => {
        if (!this.state.errored) {
            this.setState({
                src: noimage,
                errored: true,
            });
        }
    };

    render() {
        const { report } = this.props;
        const reportPic = report
            ? `./tm_plans/${report.result_plan.planRef.toLowerCase()}.png`
                ? `./tm_plans/${report.result_plan.planRef.toLowerCase()}.png`
                : noimage
            : "";
        let reportPicRequire;
        try {
            reportPicRequire = require(`${reportPic}`);
        } catch (e) {
            reportPicRequire = noimage;
        }

        const ukPic = report
            ? `./tm_plans/uk/${report.result_plan.planRef.toLowerCase()}.png`
                ? `./tm_plans/uk/${report.result_plan.planRef.toLowerCase()}.png`
                : false
            : false;
        let uk_pic;
        try {
            uk_pic = require(`${ukPic}`);
        } catch (e) {
            uk_pic = false;
        }
        const pic =
            this.props.IsClientInUK && uk_pic ? uk_pic : reportPicRequire;

        let title;
        let logosrc = '';
        var logos = require("./logos.json");
        if(this.props.clientDetails){
            title = this.props.clientDetails.title
            title = title.split(' ').join('_');
            var lastChar = title.substr(title.length - 1);
            if(lastChar === '_'){
                title = title.substring(0, title.length - 1);
            }
            //console.log(title,"title")
            //title = title.replace("_Staging", "");
            logosrc = logos[title]
        }
        return (
            <Card>
                <StyledHeader style={{ background: "#0188cc" }}>
                    <Typography variant="h5" style={{ color: "white" }}>
                        TM Plan{" "}
                        <ReactToPrint
                            onBeforePrint={() => {
                                document.title =
                                    "TM Plan - " +
                                    this.props.match.params.report_id
                                        .replace(/_/g, " ")
                                        .replace(/\./g, ":");
                            }}
                            onAfterPrint={() => {
                                document.title = this.state.title;
                                this.setState({ isPrintModalOpen: true });
                            }}
                            trigger={() => (
                                <PrintIcon
                                    style={{
                                        float: "right",
                                        fontSize: "36px",
                                        marginRight: "30px",
                                        cursor: "pointer",
                                    }}
                                />
                            )}
                            content={() => this.componentRef}
                        />
                    </Typography>
                </StyledHeader>
                {report && (
                    <CardContent>
                        <Print ref={(el) => (this.componentRef = el)}>
                            <Grid container spacing={4}>
                                <Grid item xl={8} xs={8} sm={8}>
                                    <Grid container spacing={4}>
                                        <Grid item xl={12} xs={12}>
                                            <img
                                                style={{ width: "100%" }}
                                                src={pic}
                                                onError={this.onError}
                                                alt="TMPlan InProgress"
                                            />
                                        </Grid>
                                        <Grid item xl={3} sm={3} xs={3}>
                                            <div
                                                ref={(element) => {
                                                    this.designParamsRef = element;
                                                }}
                                            >
                                                <Typography
                                                    variant="title"
                                                    style={{
                                                        color: "blue",
                                                        marginBottom: 20,
                                                    }}
                                                >
                                                    Design Parameters
                                                </Typography>
                                                <DrawingInfo
                                                    label="Speed Limit"
                                                    text={
                                                        report.result_plan.speed
                                                    }
                                                />
                                                <DrawingInfo
                                                    label="Min. Visibility To Signs"
                                                    text={
                                                        report.result_plan
                                                            .minVisibility
                                                    }
                                                />
                                                <DrawingInfo
                                                    label="Cumulative Distance"
                                                    text={
                                                        report.result_plan
                                                            .cumulativeDistance
                                                    }
                                                />
                                                <DrawingInfo
                                                    label="Number of Adv. Signs"
                                                    text={
                                                        report.result_plan
                                                            .noAdvanceSigns
                                                    }
                                                />
                                                <DrawingInfo
                                                    label="Longitudinal Safety Zones (M)"
                                                    text={
                                                        report.result_plan
                                                            .longSafeZone
                                                    }
                                                />
                                                <DrawingInfo
                                                    label="Lateral Safety Zone"
                                                    text={
                                                        report.result_plan
                                                            .latSafeZone
                                                    }
                                                />
                                                <DrawingInfo
                                                    label="Longitudinal Cone Space"
                                                    text={
                                                        report.result_plan
                                                            .longConeSpace
                                                    }
                                                />
                                                <DrawingInfo
                                                    label="Cone Spacing At Tapers (M)"
                                                    text={
                                                        report.result_plan
                                                            .tapConeSpace
                                                    }
                                                />
                                            </div>
                                        </Grid>
                                        {typeof report.attached_photos === "undefined"
                                            ?
                                            <Grid item xl={3} sm={3} xs={3}>
                                                <div
                                                    style={{
                                                        height: "auto",
                                                    }}
                                                >
                                                    <Typography
                                                        variant="title"
                                                        style={{ color: "blue" }}
                                                    >
                                                        Site Photo's
                                                </Typography>

                                                    <div
                                                        style={{
                                                            padding: 10,
                                                            border:
                                                                "1px solid grey",
                                                            textAlign: "center"
                                                        }}
                                                    >
                                                        <img
                                                            src={
                                                                noImg
                                                            }
                                                            alt="Site"
                                                            style={{
                                                                cursor:
                                                                    "pointer",
                                                                width:
                                                                    "75%",
                                                                height:
                                                                    "auto",
                                                                borderRadius: 10,
                                                                marginTop: 10,
                                                            }}
                                                        />
                                                        <p style={{ fontSize: "10px" }}>
                                                            <b>No Photo's Attached</b>
                                                        </p>{" "}
                                                    </div>
                                                </div>
                                            </Grid>
                                            :
                                            <Grid item xl={3} sm={3} xs={3}>
                                                <div
                                                    style={{
                                                        height: "auto",
                                                    }}
                                                >
                                                    <Typography
                                                        variant="title"
                                                        style={{ color: "blue" }}
                                                    >
                                                        Site Photo's
                                            </Typography>

                                                    {report.attached_photos &&
                                                        report.attached_photos.map(
                                                            (e) => {
                                                                return (
                                                                    <div
                                                                        style={{
                                                                            padding: 10,
                                                                            border:
                                                                                "1px solid grey",
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={
                                                                                e.photo_url
                                                                            }
                                                                            onClick={() => {
                                                                                this.setState(
                                                                                    {
                                                                                        photos: e,
                                                                                        isImgModalOpen: true,
                                                                                    }
                                                                                );
                                                                            }}
                                                                            alt="Site"
                                                                            style={{
                                                                                cursor:
                                                                                    "pointer",
                                                                                width:
                                                                                    "66%",
                                                                                height:
                                                                                    "auto",
                                                                                borderRadius: 10,
                                                                                marginTop: 10,
                                                                            }}
                                                                        />
                                                                        <Typography variant="body1">
                                                                            <b>
                                                                                Name:
                                                                    </b>{" "}
                                                                            {
                                                                                e.photo_name
                                                                            }
                                                                            <br />
                                                                            <b>
                                                                                Timestamp:
                                                                    </b>{" "}
                                                                            {
                                                                                e.photo_timestamp
                                                                            }
                                                                        </Typography>{" "}
                                                                    </div>
                                                                );
                                                            }
                                                        )}
                                                </div>
                                            </Grid>

                                        }
                                        {typeof report.attached_sketches === "undefined"
                                            ?
                                            <Grid item xl={3} sm={3} xs={3}>
                                                <div
                                                    style={{
                                                        height: "auto",
                                                    }}
                                                >
                                                    <Typography
                                                        variant="title"
                                                        style={{ color: "blue" }}
                                                    >
                                                        TM Sketches
                                                </Typography>

                                                    <div
                                                        style={{
                                                            padding: 10,
                                                            border:
                                                                "1px solid grey",
                                                            textAlign: "center"
                                                        }}
                                                    >
                                                        <img
                                                            src={
                                                                noImg
                                                            }
                                                            alt="Site"
                                                            style={{
                                                                cursor:
                                                                    "pointer",
                                                                width:
                                                                    "66%",
                                                                height:
                                                                    "auto",
                                                                borderRadius: 10,
                                                                marginTop: 10,
                                                            }}
                                                        />
                                                        <p style={{ fontSize: "10px" }}>
                                                            <b>No Sketch Attached</b>
                                                        </p>{" "}
                                                    </div>
                                                </div>
                                            </Grid>
                                            :
                                            <Grid item xl={3} sm={3} xs={3}>
                                                <div
                                                    style={{
                                                        height: "auto",
                                                    }}
                                                >
                                                    <Typography
                                                        variant="title"
                                                        style={{ color: "blue" }}
                                                    >
                                                        TM Sketches
                                                    </Typography>
                                                    {report.attached_sketches &&
                                                        report.attached_sketches.map(
                                                            (e) => {
                                                                return (
                                                                    <div
                                                                        style={{
                                                                            padding: 10,
                                                                            border:
                                                                                "1px solid grey",
                                                                        }}
                                                                    >
                                                                        <img
                                                                            onClick={() => {
                                                                                this.setState(
                                                                                    {
                                                                                        photos: e,
                                                                                        isImgModalOpen: true,
                                                                                    }
                                                                                );
                                                                            }}
                                                                            src={
                                                                                e.photo_url ||
                                                                                noImg
                                                                            }
                                                                            alt="Site"
                                                                            style={{
                                                                                cursor:
                                                                                    "pointer",
                                                                                width:
                                                                                    "66%",
                                                                                height:
                                                                                    "auto",
                                                                                borderRadius: 10,
                                                                                marginTop: 10,
                                                                            }}
                                                                        />
                                                                        <Typography variant="body1">
                                                                            <b>
                                                                                Name:
                                                                            </b>{" "}
                                                                            {
                                                                                e.photo_name
                                                                            }
                                                                            <br />
                                                                            <b>
                                                                                Timestamp:
                                                                            </b>{" "}
                                                                            {
                                                                                e.photo_timestamp
                                                                            }
                                                                        </Typography>{" "}
                                                                    </div>
                                                                );
                                                            }
                                                        )}
                                                </div>
                                            </Grid>
                                        }

                                        <Grid item xl={3} sm={3} xs={3}>
                                            <MapDiv>
                                                <Typography
                                                    variant="title"
                                                    style={{ color: "blue" }}
                                                >
                                                    Job Address
                                                </Typography>
                                                <MapContainer
                                                    lat={report.location_lat}
                                                    long={report.location_lon}
                                                />
                                            </MapDiv>
                                        </Grid>
                                    </Grid>
                                    <Typography
                                        variant="title"
                                        style={{ color: "blue" }}
                                    >
                                        Job Address
                                    </Typography>
                                    {report.address}
                                </Grid>
                                <Grid
                                    item
                                    xl={3}
                                    sm={3}
                                    xs={3}
                                    style={{
                                        backgroundColor: "lightgray",
                                        borderRadius: "15px",
                                        padding: "10px",
                                    }}
                                >
                                    <Typography
                                        variant="h6"
                                        style={{ color: "blue" }}
                                    >
                                        Drawing Details
                                    </Typography>
                                    <Typography
                                        variant="caption"
                                        style={{
                                            borderBottom: "4px solid blue",
                                            marginTop: 10,
                                            marginBottom: 10,
                                        }}
                                    >
                                        <b>
                                            THIS MAY ONLY BE USED FOR THE
                                            PURPOSE INTENDED AND ONLY WRITTEN
                                            DIMENSIONS MAY BE USED
                                        </b>
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        style={{
                                            textAlign: "center",
                                        }}
                                    >
                                        <b>LEGEND</b>
                                    </Typography>
                                    <LegendDiv
                                        text="Works Area"
                                        img={require("./legends/works.png")}
                                    />
                                    <LegendDiv
                                        text="Taper"
                                        img={require("./legends/tape.png")}
                                    />
                                    <LegendDiv
                                        text="Longitudinal Safety Zone"
                                        img={require("./legends/longitudinal.png")}
                                    />
                                    <LegendDiv
                                        text="Lateral Safety Zone"
                                        img={require("./legends/lateral.png")}
                                    />
                                    <LegendDiv
                                        text="Pedestrian Barrier"
                                        img={require("./legends/pedestrian.png")}
                                    />
                                    <LegendDiv
                                        text="Cone "
                                        img={require("./legends/cone.png")}
                                    />
                                    <LegendDiv
                                        text="Sign Location"
                                        img={require("./legends/sign.png")}
                                    />
                                    <Typography
                                        variant="body1"
                                        style={{ borderTop: "4px solid blue" }}
                                    >
                                        1. ALL SIGNS TO COMPLY WITH CHAPTERS OF
                                        THE TRAFFIC SIGNS MANUAL
                                    </Typography>
                                    <Typography variant="body1">
                                        2. ALL SIGNAGE SET OUT BY QUALIFIED
                                        SIGNING, LIGHTING & GUARDING ROADWORKS
                                        PERSONNEL
                                    </Typography>
                                    <Typography variant="body1">
                                        3. ON COMPLETION OF OF SIGNAGE SET UP
                                        TRAINED PERSONNEL TO SIGN OFF ON SCHEME
                                        TO ENSURE IT COMPLIES WITH TMP
                                    </Typography>
                                    <Typography variant="body1">
                                        4. ALL SIGNS AND ALL CONES MAINTAINED AT
                                        ALL TIMES
                                    </Typography>
                                    <Typography variant="body1">
                                        5. END OF ROADWORKS SIGN TO BE PLACE
                                        20-50M FROM END OF ROADWORKS
                                    </Typography>
                                    <Typography variant="body1">
                                        6.{" "}
                                        {report.result_plan.note6 !== ""
                                            ? report.result_plan.note6
                                            : "No Additional Notes"}
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        style={{
                                            borderBottom: "4px solid blue",
                                        }}
                                    >
                                        7.{" "}
                                        {report.result_plan.note7 !== ""
                                            ? report.result_plan.note7
                                            : "No Additional Notes"}
                                    </Typography>
                                    <DrawingInfo
                                        label="Plan Input By"
                                        text={report.user_name}
                                    />
                                    <DrawingInfo
                                        label="Date"
                                        text={report.timestamp}
                                    />
                                    <DrawingInfo
                                        label="JobPack ID"
                                        text={report.jobpack_id}
                                    />
                                    <DrawingInfo
                                        label="Database Plan ID"
                                        text={report.result_plan.planRef}
                                    />

                                    <div style={{ display: "none" }}>
                                        {report.attached_signature.signature_url.includes(
                                            "https:"
                                        )
                                            ? ""
                                            : (ref =
                                                "data:image/png;base64," +
                                                report.attached_signature
                                                    .signature_url)}
                                    </div>

                                    {report.attached_signature.signature_url === "" ?
                                        <>
                                        <img
                                                src={noSig}
                                                style={{
                                                   
                                                    width: "45%",
                                                    margin: "2%",
                                                }}
                                                alt="No Signature"
                                            />
                                        </>
                                        :
                                        <>
                                        {report.attached_signature.signature_url.includes(
                                        "https:"
                                    ) ? (
                                        
                                            <img
                                                src={
                                                    report.attached_signature
                                                        .signature_url
                                                        ? report.attached_signature
                                                            .signature_url
                                                        : noSig
                                                }
                                                style={{
                                                   
                                                    width: report.attached_signature.signature_url === "" ? "60%" : "96%",
                                                    margin: "2%",
                                                }}
                                                alt="Signature"
                                            />
                                        ) : (
                                            <img
                                                src={ref ? ref : noSig}
                                                style={{
                                                    width: ref === "" ? "60%" : "96%",
                                                    margin: "2%",
                                                }}
                                                alt="Signature"
                                                // onError={(ev) => {
                                                //     ev.target.src = noSig
                                                // }}
                                            />
                                        )}
                                        </>
                                    }
                                    
                                    <img
                                        src={
                                            logosrc
                                                ? logosrc
                                                : noImg
                                        }
                                        style={{ width: "98%", margin: "2%" }}
                                        alt="Logo"
                                        onError={(ev) => {
                                            ev.target.src = noImg
                                        }}
                                    />

                                </Grid>
                                <Grid item xl={12} sm={12} xs={12}>
                                    <Grid container spacing={4}>
                                        <Grid item sm={1} xs={1} xl={1}>
                                            <DrawingInfoBottom
                                                label="Speed"
                                                text={report.user_input.speed}
                                            />
                                        </Grid>
                                        <Grid item sm={1} xs={1} xl={1}>
                                            <DrawingBottom
                                                label="Road Width"
                                                text={
                                                    report.user_input
                                                        .roadwayWidth
                                                }
                                            />
                                        </Grid>
                                        <Grid item sm={1} xs={1} xl={1}>
                                            <DrawingInfoBottom
                                                label="Road Type"
                                                text={
                                                    report.user_input.roadType
                                                }
                                            />
                                        </Grid>
                                        <Grid item sm={1} xs={1} xl={1}>
                                            <DrawingInfoBottom
                                                label="Road Layout"
                                                text={
                                                    report.user_input.roadLayout
                                                }
                                            />
                                        </Grid>
                                        <Grid item sm={1} xs={1} xl={1}>
                                            <DrawingInfoBottom
                                                label="Visibility"
                                                text={
                                                    report.user_input
                                                        .minVisibility
                                                }
                                            />
                                        </Grid>
                                        <Grid item sm={1} xs={1} xl={1}>
                                            <DrawingInfoBottom
                                                label="Traffic Count"
                                                text={
                                                    report.user_input
                                                        .maxTrafficCount
                                                }
                                            />
                                        </Grid>
                                        <Grid item sm={1} xs={1} xl={1}>
                                            <DrawingInfoBottom
                                                label="Time"
                                                text={report.user_input.time}
                                            />
                                        </Grid>
                                        <Grid item sm={1} xs={1} xl={1}>
                                            <DrawingInfoBottom
                                                label="Unobstructed Width"
                                                text={
                                                    report.user_input
                                                        .minUnobstructedWidth
                                                }
                                            />
                                        </Grid>
                                        <Grid item sm={1} xs={1} xl={1}>
                                            <DrawingInfoBottom
                                                label="Site Length"
                                                text={
                                                    report.user_input
                                                        .maxSiteLength
                                                }
                                            />
                                        </Grid>
                                        <Grid item sm={1} xs={1} xl={1}>
                                            <DrawingInfoBottom
                                                label="Lighting"
                                                text={
                                                    report.user_input.lighting
                                                }
                                            />
                                        </Grid>
                                        <Grid item sm={1} xs={1} xl={1}>
                                            <DrawingInfoBottom
                                                label="Road Part"
                                                text={
                                                    report.user_input.roadPart
                                                }
                                            />
                                        </Grid>
                                    </Grid>

                                    {typeof report.notes === "undefined" ? (
                                        ""
                                    ) : (
                                            <>
                                                <Label for="notes">
                                                    <b>Key Note:</b> {report.notes}
                                                </Label>
                                            </>
                                        )}
                                </Grid>
                            </Grid>
                        </Print>
                    </CardContent>
                )}
                {report && (
                    <Modal isOpen={this.state.isPrintModalOpen}>
                        <ModalHeader>Print associated SOP</ModalHeader>
                        <ModalBody>
                            <Typography>
                                Do you want to print the following PDF
                                associated with this TM Plan?(Please use print
                                button inside the PDF view)
                            </Typography>
                            {require(`./SOPs/${report.result_plan.sop}.pdf`) && (
                                <iframe
                                    id={"printIframe"}
                                    title={"printIframe"}
                                    width="100%"
                                    height="500"
                                    src={require(`./SOPs/${report.result_plan.sop}.pdf`)}
                                />
                            )}
                            {!require(`./SOPs/${report.result_plan.sop}.pdf`) && (
                                <Typography>PDF is not available!</Typography>
                            )}
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                onClick={() => {
                                    this.setState({ isPrintModalOpen: false });
                                }}
                                variant="contained"
                            >
                                Cancel
                            </Button>
                        </ModalFooter>
                    </Modal>
                )}
                {report && (
                    <Modal isOpen={this.state.isImgModalOpen}>
                        <ModalHeader>Print Attached Photo/Sketches</ModalHeader>
                        <ModalBody
                            ref={(edl) => (this.componentPhotoRef = edl)}
                        >
                            <img
                                ref={(edl) => (this.componentPhotoRef = edl)}
                                src={
                                    this.state.photos
                                        ? this.state.photos.photo_url
                                        : noImg
                                }
                                alt="Site"
                                style={{
                                    width: "100%",
                                    height: "auto",
                                    borderRadius: 10,
                                }}
                            />
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                onClick={() => {
                                    this.setState({
                                        photos: false,
                                        isImgModalOpen: false,
                                    });
                                }}
                                variant="contained"
                            >
                                Cancel
                            </Button>
                            <ReactToPrint
                                onBeforePrint={() => {
                                    document.title =
                                        "TM Plan - Photo - " +
                                        this.props.match.params.report_id
                                            .replace(/_/g, " ")
                                            .replace(/\./g, ":");
                                }}
                                onAfterPrint={() => {
                                    document.title = this.state.title;
                                }}
                                trigger={() => (
                                    <Button color="primary" variant="contained">
                                        Print
                                    </Button>
                                )}
                                content={() => this.componentPhotoRef}
                            />
                        </ModalFooter>
                    </Modal>
                )}
            </Card>
        );
    }
}
const LegendDiv = (props) => {
    return (
        <div
            style={{
                display: "flex",
                marginTop: 20,
            }}
        >
            <img
                src={props.img}
                alt="legend icon"
                style={{ height: 40, marginRight: 40, marginLeft: "20%" }}
            />
            <Typography variant="body1">{props.text}</Typography>
        </div>
    );
};
const DrawingInfo = (props) => {
    return (
        <div style={{ display: "flex", marginBottom: 15 }}>
            <Typography variant="body1" style={{width: "100%" }}>
                <b>{props.label}:</b>&nbsp;{props.text}
            </Typography>
            {/* <Typography variant="body1"></Typography> */}
        </div>
    );
};
const DrawingInfoBottom = (props) => {
    return (
        <div style={{ marginBottom: 15 }}>
            <Typography
                variant="body1"
                style={{ textAlign: "center", width: "100%" }}
            >
                <b>{props.label}:</b>
            </Typography>
            <Typography
                variant="body1"
                style={{ textAlign: "center", width: "100%" }}
            >
                {props.text}
            </Typography>
        </div>
    );
};
const DrawingBottom = (props) => {
    return (
        <div style={{ marginBottom: 15 }}>
            <Typography
                variant="body1"
                style={{ textAlign: "center", width: "100%" }}
            >
                <b>{props.label}:</b>
            </Typography>
            <Typography
                variant="body1"
                style={{
                    textAlign: "center",
                    width: "100%",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                }}
            >
                {props.text}
            </Typography>
        </div>
    );
};
export default connect(
    (store) => {
        return {
            report: selectReport(store),
            ukClient: IsClientInUK(store),
            clientDetails: clientDetails(store)
        };
    },
    { getReport, getJobPackReports }
)(TMPlan);
